import script from "./ResearchPreferenceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearchPreferenceDialog.vue?vue&type=script&setup=true&lang=js"

import "./ResearchPreferenceDialog.vue?vue&type=style&index=0&id=676ee8a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676ee8a0"]])

export default __exports__